<div class="forgot-page">
  <div class="form-section">

    <h1 class="page-title">Reset Your Password</h1>
    <p class="page-subtitle">
      Enter your account email and we'll send you a link to get back in.
    </p>

    <form [formGroup]="recoverPasswordForm" (ngSubmit)="onRecoverPassword()" novalidate>
      <div class="form-group">
        <input
          id="email"
          formControlName="email"
          type="email"
          class="form-control"
          placeholder="Email Address"
          required
        />
      </div>

      <button type="submit" class="reset-btn">Send Reset Link</button>

      <button type="button" class="reset-btn secondary" (click)="onEmailLinkRecovery()">Email me a sign-in link instead</button>

      <p class="text-muted small-hint" *ngIf="isLoggedIn">
        Signed in on this device? You can send a link to add or confirm email sign-in for reauthentication.
        <button type="button" class="inline-link" (click)="onLinkEmailForSignedInUser()">Send link-to-link email</button>
      </p>

      <p class="text-success" *ngIf="successMessage">{{ successMessage }}</p>
      <p class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</p>
      <p class="text-info" *ngIf="emailLinkInfo">{{ emailLinkInfo }}</p>
    </form>

    <div class="back-link">
      <a routerLink="/auth/log-in">← Back to Sign In</a>
    </div>

  </div>
</div>